import React from 'react';
import PropTypes from 'prop-types';
import { getAllParams } from '../service/utils';

const AccessibilityClickableDiv = ({ onClick, children, isDisable, style, ...params }) => {

  const handleClick = (event) => {
    // Trigger the onClick function when the Enter key is pressed
    if (event.key === 'Enter' && onClick) {
      onClick(event);
    }
  };

  // Prepare additional props
  const additionalProps = {
    onClick,
    onKeyDown: handleClick,
    style: style,
    role: "button",
    tabIndex: isDisable ? -1 : 0,
    ...getAllParams(params)
  };

  return <div {...additionalProps}>{children}</div>;
};

AccessibilityClickableDiv.propTypes = window.config.developMode ? {
  onClick: PropTypes.func.isRequired
} : {};

export default AccessibilityClickableDiv;
